import { VOImage } from "../../model/DataStructure.js";
import { AbstractImageItem } from "./AbstractImageItem.js";

export class PixiImageItem extends AbstractImageItem<PIXI.Sprite> {

    constructor(image: VOImage, screenWidth: number) {
        super(image, screenWidth);
    }

    protected createElement(image: VOImage): void {
        var t = PIXI.Texture.from(image.canvas ? image.canvas : image.image.url);
        this.element = new PIXI.Sprite(t);
    }

    protected setVisibility(visible: boolean): void {
        this.element.visible = visible;
    }

    protected setTransform(x: number, y: number, scale:number): void {
        this.element.position.set(x, y);
        this.element.scale.set(scale);
    }
}